import {
  FileText,
  PackageCheck,
  Truck,
  Building2,
  ShieldQuestion,
  ShieldAlert,
  ShieldCheck,
  Bike,
  CheckCircle2,
  RotateCcw,
  AlertTriangle,
} from "lucide-react";

export const STATUS_META = {
  label_created: { label: "Label Created", icon: FileText, tone: "neutral" },
  picked_up: { label: "Picked Up", icon: PackageCheck, tone: "info" },
  in_transit: { label: "In Transit", icon: Truck, tone: "info" },
  arrived_at_facility: { label: "Arrived at Facility", icon: Building2, tone: "info" },
  customs_clearance_in_progress: { label: "Customs Clearance in Progress", icon: ShieldQuestion, tone: "customs" },
  held_by_customs: { label: "Held by Customs", icon: ShieldAlert, tone: "customs" },
  released_by_customs: { label: "Released by Customs", icon: ShieldCheck, tone: "success" },
  out_for_delivery: { label: "Out for Delivery", icon: Bike, tone: "info" },
  delivered: { label: "Delivered", icon: CheckCircle2, tone: "success" },
  delivery_attempted: { label: "Delivery Attempted", icon: RotateCcw, tone: "warning" },
  exception: { label: "Exception", icon: AlertTriangle, tone: "danger" },
};

export const CUSTOMS_STATUSES = new Set([
  "customs_clearance_in_progress",
  "held_by_customs",
  "released_by_customs",
]);

export const TONE_CLASSES = {
  neutral: "bg-slate-100 text-slate-700 border-slate-200",
  info: "bg-sky-50 text-sky-700 border-sky-200",
  success: "bg-emerald-50 text-emerald-700 border-emerald-200",
  warning: "bg-amber-50 text-amber-700 border-amber-200",
  customs: "bg-amber-50 text-amber-800 border-amber-300",
  danger: "bg-red-50 text-red-700 border-red-200",
};

export function statusMeta(value) {
  return STATUS_META[value] || { label: value, icon: FileText, tone: "neutral" };
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString(undefined, {
      year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
  } catch {
    return iso;
  }
}
